<template>
  <div class="step4-confirm-config">
    <!-- Section 1: 资金收款户主体信息 -->
    <div class="info-section">
      <div class="section-header">
        <div class="blue-bar"></div>
        <span class="section-title">资金收款户主体信息</span>
      </div>

      <div class="info-grid">
        <div class="info-item">
          <span class="label">企业主体全称：</span>
          <span class="value">{{ (entity && entity.corporationName) || '--' }}</span>
        </div>
        <div class="info-item">
          <span class="label">统一社会信用代码：</span>
          <span class="value">{{ (entity && entity.licenceNo) || '--' }}</span>
        </div>
        <div class="info-item">
          <span class="label">法人姓名：</span>
          <span class="value">{{ (entity && entity.legalName) || '--' }}</span>
        </div>

        <div class="info-item">
          <span class="label">法人手机号：</span>
          <span class="value">{{ (entity && entity.legalMobile) || '--' }}</span>
        </div>
        <div class="info-item">
          <span class="label">法人身份证号：</span>
          <span class="value">{{ (entity && entity.legalIdNo) || '--' }}</span>
        </div>
        <div class="info-item">
          <span class="label">联系人姓名：</span>
          <span class="value">{{ (entity && entity.contactName) || '--' }}</span>
        </div>

        <div class="info-item">
          <span class="label">联系人手机号：</span>
          <span class="value">{{ (entity && entity.contactMobile) || '--' }}</span>
        </div>
        <div class="info-item">
          <span class="label">联系地址：</span>
          <span class="value">{{ (entity && entity.contactAddress) || '--' }}</span>
        </div>
      </div>
    </div>

    <!-- Section 2: 资金划扣配置 -->
    <div class="info-section">
      <div class="section-header">
        <div class="blue-bar"></div>
        <span class="section-title">资金划扣配置</span>
      </div>

      <div class="info-grid">
        <div class="info-item">
          <span class="label">合作网约平台：</span>
          <span class="value">{{ (authInfo && authInfo.spName) || '--' }}</span>
        </div>
        <div class="info-item">
          <span class="label">授权有效期：</span>
          <span class="value">{{ (authInfo && authInfo.validPeriod) || '--' }}</span>
        </div>
        <div class="info-item">
          <span class="label">授权划扣范围：</span>
          <span class="value">{{ (authInfo && authInfo.scope) || '--' }}</span>
        </div>

        <div class="info-item">
          <span class="label">
            延长划扣天数:
            <el-tooltip content="退车解约后可继续扣款的最大天数" placement="top">
              <i class="el-icon-question" style="color: #999; cursor: pointer; margin-left: 4px;"></i>
            </el-tooltip>
          </span>
          <span class="value">{{ (authInfo && authInfo.extendDay) ? authInfo.extendDay + '天' : '--' }}</span>
        </div>
        <div class="info-item">
          <span class="label">资金代付周期：</span>
          <span class="value">{{ (authInfo && authInfo.payPeriodStr) || '--' }}</span>
        </div>
      </div>
    </div>

    <!-- Section 3: 提现银行卡配置 -->
    <div class="info-section">
      <div class="section-header">
        <div class="blue-bar"></div>
        <span class="section-title">提现银行卡配置</span>
      </div>

      <el-form ref="formRef" :model="form" :rules="rules" label-position="top" class="bank-form">
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="static-field">
              <div class="label">开户银行</div>
              <div class="value">浙江网商银行</div>
            </div>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="bankCardNumber" label="银行卡号" class="custom-form-item">
              <span slot="label" class="custom-label">银行卡号</span>
              <el-input
                v-model="form.bankCardNumber"
                placeholder="请输入开头为 88888******的银行账户编号"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, defineExpose } from 'vue'

const props = defineProps({
  entity: {
    type: Object,
    default: () => ({}),
  },
  authInfo: {
    type: Object,
    default: () => ({}),
  },
})

const formRef = ref(null)
const form = reactive({
  bankCardNumber: '',
})

const rules = {
  bankCardNumber: [
    { required: true, message: '请输入银行卡号', trigger: 'blur' },
    { pattern: /^88888/, message: '银行卡号必须以 88888 开头', trigger: 'blur' },
  ],
}

const validate = (callback) => {
  formRef.value.validate((valid) => {
    callback(valid, form)
  })
}

defineExpose({
  validate,
})
</script>

<style scoped lang="scss">
.step4-confirm-config {
  padding-top: 10px;
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  padding-left: 0;

  .blue-bar {
    width: 4px;
    height: 16px;
    background: #409EFF;
    margin-right: 8px;
    border-radius: 2px;
  }

  .section-title {
    font-size: 14px;
    font-weight: 500;
    color: #303133;
  }
}

.info-section {
  background: #F5F7FA;
  border-radius: 4px;
  padding: 16px;
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }
}

.info-grid {
  display: flex;
  flex-wrap: wrap;

  .info-item {
    width: 33.33%;
    margin-bottom: 12px;
    font-size: 13px;
    line-height: 20px;
    display: flex;

    .label {
      color: #909399;
      width: 120px;
      flex-shrink: 0;
      text-align: right;
      padding-right: 8px;
    }

    .value {
      color: #303133;
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.bank-form {
  ::v-deep .el-form-item .el-form-item__label {
    justify-content: flex-start;
  }
  .static-field {
    margin-bottom: 22px;
    .label {
      font-size: 14px;
      color: #606266;
      line-height: 1.5;
      margin-bottom: 8px;
    }
    .value {
      font-size: 14px;
      color: #303133;
    }
  }

  .custom-form-item {
    margin-bottom: 0;
  }

  .custom-label {
    .required-star {
      color: #F56C6C;
      margin-right: 4px;
    }
  }
}
</style>
